/**
 * Section teaser component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Button from '../button/button';
import Image from '../image/image';

export default class SectionTeaser extends PureComponent {

	render() {
		
		const { data } = this.props;

		const alignment = 'section-' + data.alignment.toLowerCase();
		const classes = 'section section-teaser ' + alignment;
		
		return (
			
			<div className={classes}>
				<div className="section-content">

					{ !! data.title && <h2>{data.title}</h2> }
					{ !! data.lead && <h3>{data.lead}</h3> }
					{ !! data.text && <p>{data.text}</p> }

					{ !! data.link && <Button url={data.link} label={data.link_label} color="primary" size="" /> }

				</div>
				<div className="section-graphic">

					<figure className="section-cover"><Image data={data.image}/></figure>

				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/sections/section-teaser.js